// removed by extract-text-webpack-plugin
module.exports = {"phones":"SN9jCrYKVaAoL-vJ","phone-link":"_2FHWuEt7s60TAkxg"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/common/components/object_phone_show/object_phone_show.css
// module id = 734
// module chunks = 0